import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Table, Input } from 'antd';
import TableText from "../TableText";
import { columnsData, } from './data';
import { toJS, runInAction, action } from 'mobx';


const { TextArea } = Input;


@inject('store')
@observer
class App extends Component {
    render() {
        const { cost, notes, loading } = this.props.store.monthlyAnalysis;
        const width = document.body.offsetWidth > 2100 ? document.body.offsetWidth - 1800 : 300;
        const columns = columnsData.map(item => {
            if (item.key == 'name') {
                return {
                    title: item.title,
                    dataIndex: item.key,
                    key: item.key,
                    fixed: 'left',
                    width,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: item.type,
                            name: item.key,
                            onChange: this.onChange,
                            totalIndex: [],

                        };
                        return <TableText data={{ ...props }} />
                    }
                }
            }
            return {
                title: item.title,
                dataIndex: item.key,
                key: item.key,
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: "percent",
                        name: item.key,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: {
                            title: [item.title],
                            record,
                            sqlName: "monthlyAnalysis_cost"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }
        })
        return (
            <div className="">
                <Row className="secondary_title">四．主要成本分析</Row>
                <div className="text_c"><span className="span_41">（1）</span>食品成本率=食品及饮品成本/餐饮收入</div>
                <div className="text_c text_indent m_b_10">食品成本率（大于百分之三十五需要做出解释）</div>
                <div className="text_c"><span className="span_41">（2）</span>人力成本率=人力成本/总收入</div>
                <div className="text_c text_indent m_b_10">人力成本率（大于百分之三十需要做出解释）</div>
                <div className="text_c"><span className="span_41">（3）</span>能源成本率=能源成本/总收入</div>
                <div className="text_c text_indent m_b_10">能源成本率（大于百分之十需要做出解释）</div>
                <div className="text_c"><span className="span_41">（4）</span>其他费用及成本率=其他费用及成本/总收入</div>
                <div className="text_c text_indent m_b_10">其他费用及成本率（相比预算正负百分之五范围内）</div>
                <Table
                    columns={columns}
                    dataSource={cost}
                    size="middle"
                    bordered
                    pagination={false}
                    className="content"
                    rowKey={(record, index) => index}
                    scroll={{ x: 2100 }}
                />
                <Row className="note_title">酒店的主要成本趋势分析</Row>
                {!loading && <TextArea
                    className="note m_b_80"
                    autosize={{ minRows: 8 }}
                    defaultValue={notes.cost}
                    onBlur={e => {
                        runInAction(() => {
                            this.props.store.monthlyAnalysis.notes.cost = e.target.value || "";
                        })
                    }}
                    placeholder={`示例：\n（1）食品成本率多少，主要是因为酒店自助餐的促销活动，所以影响西餐厅食品成本率多少，未来改善计划。 \n（2）人力成本率多少，按照酒店的客情情况，各部门是否做到合理排版，按照未来预测的情况是否需要改进。\n（3）能源成本率多少，按照酒店实际的入住率以及天气变化情况，影响到当月的能源支出多少，未来从哪方面进行改善 \n（4）其他费用及成本率根据预算比率做出解释，未来改善计划。`}
                />}
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/table/monthlyAnalysis/CostAnalysis.js